if (!customElements.get('engraving-component')) {
  customElements.define(
    'engraving-component',
    class EngravingComponent extends HTMLElement {
      constructor() {
        super();

        const sectionId = this.dataset.section;
        // const engravingTextInput = this.querySelector('.engraving-content input');

        this.inputs = this.querySelectorAll('.engraving-input');
        this.inputs.forEach(input => {
            input.addEventListener('click', (event) => {
                if (event.currentTarget.value == 'Yes') {
                    this.querySelector('.engraving-content').classList.remove('hidden');
                    this.querySelector('.engraving-content input').disabled = false;
                } else {
                    this.querySelector('.engraving-content').classList.add('hidden');
                    this.querySelector('.engraving-content input').disabled = true;
                }
            });
        });

        // engravingTextInput.addEventListener('input', () => {
        //     const value = engravingTextInput.value.trim();
        //     if (value !== '') {
        //         engravingTextInput.setAttribute('form', sectionId);
        //     } else {
        //         engravingTextInput.removeAttribute('form');
        //     }
        // });
      }
    }
  );
}
